import type { BasketMessageClickAndCollectViewModel } from 'autogen/swagger/all';
import { Typography } from 'components/generic/typography';
import styled from 'styled-components';
import BasketMessageContainer from '../shared/styles';
import format from 'helpers/translations';
import InlineButton from 'components/generic/InlineButton';
import { useQuickView } from 'components/quickView';
import { GA4Tracking } from 'modules/tracking/GA4/GA4Tracking';
import { useTranslation } from 'react-i18next';
import { DisclaimerLink } from 'autogen/translation-keys/trans-website-basket-deliveryfix';

const StyledBasketMessageContainer = styled(BasketMessageContainer)<{
    $type: BasketMessageClickAndCollectViewModel['type'];
}>`
    background-color: ${({ $type, theme }) => ($type === 'Achievement' ? theme.ColorBackgroundSuccessLight : theme.ColorBackgroundWarningLight)};
`;

const StyledInlineButton = styled(InlineButton)`
    margin-left: ${({ theme }) => theme.Spacing4};
`;

export default function ClickAndCollectMessage({
    model: { text, type }
}: { model: BasketMessageClickAndCollectViewModel }) {
    const { toggle } = useQuickView('antiBreakQuickView');
    const { t } = useTranslation();

    function handleClick() {
        toggle(true);
        GA4Tracking({
            eventName: 'open_modal',
            context: 'basket',
            category: 'ecommerce',
            eventParams: [
                {
                    param_name: 'modal_type',
                    param_value: 'anti_break'
                },
                {
                    param_name: 'trigger_origin',
                    param_value: 'basket_message'
                }
            ]
        });
    }

    return (
        <StyledBasketMessageContainer $type={type}>
            <Typography.Body as="span" size="S">
                {format(text)}
                {type === 'Information' && (
                    <StyledInlineButton onClick={handleClick}>{t(DisclaimerLink)}</StyledInlineButton>
                )}
            </Typography.Body>
        </StyledBasketMessageContainer>
    );
}
